var core = module.exports = {version: '1.2.3'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/~/core-js/library/modules/$.core.js
 **/